module.exports = __webpack_public_path__ + "static/customer-service-be294b847f60c0ea43c528b1de483e27.jpg";